// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"b98307ac4c4aa7d39619","147":"3b56366da98e5bd32f46","251":"bf29dcfa8c04c236e05a","265":"88cbfd9a071139a17262","352":"6e7efe2c21f281fba965"}[chunkId] + ".js";
};